export default {
  router: [
    {
      exact: true,
      path: '/cardManagement/manageDashboard',
      title: '食安证件补传',
    },
  ],
  title: '食安证件补传',
};
